export const prepareTooltip = (domains: string[]) => {
    if (domains.length <= 5) {
        return domains.map((item) => <div key={item}>{item}</div>);
    }

    return [...domains.slice(0, 4), `+ ${domains.length - 5} competitors`].map((item) => <div key={item}>{item}</div>);
};
